/** Valor vacío para react-select (placeholder seleccionable). */
export const EMPTY_SELECT_VALUE = '';

export const SELECT_LABELS = {
  opcion: 'Seleccione una opción',
  condicion: 'Seleccione la condición',
  condicionCorrelativa: 'Seleccione la condición de correlativa',
  periodoCursada: 'Seleccione el Período de Cursada',
  cuatrimestre: 'Seleccione el cuatrimestre',
  practica: 'Seleccione si es práctica',
  extinta: 'Seleccione si está extinta',
  papelesCompletos: 'Seleccione si tiene papeles completos',
  estadoInscripcion: 'Seleccione el estado',
  resultado: 'Seleccione el resultado',
  carrera: 'Seleccione la Carrera',
  carreraAcademica: 'Seleccione la Carrera Académica',
};

export function selectPlaceholder(label = SELECT_LABELS.opcion) {
  return { value: EMPTY_SELECT_VALUE, label };
}

/** Opciones react-select con placeholder como primera fila visible. */
export function withSelectPlaceholder(options, label = SELECT_LABELS.opcion) {
  const items = options.filter((option) => option.value !== EMPTY_SELECT_VALUE);
  return [selectPlaceholder(label), ...items];
}

/** Resuelve la opción de react-select desde el valor de API (código A/R o etiqueta). */
export function resolveCorrelatividadCondicionOption(options, apiCondicion, placeholderLabel = SELECT_LABELS.condicionCorrelativa) {
  const raw = (apiCondicion || '').trim();
  const match = options.find(
    (option) => option.value && (option.value.trim() === raw || option.label.trim() === raw)
  );
  if (match) {
    return match;
  }
  if (raw.toLowerCase() === 'aprobada') {
    return options.find((option) => option.value === 'A');
  }
  if (raw.toLowerCase() === 'regular') {
    return options.find((option) => option.value === 'R');
  }
  return selectPlaceholder(placeholderLabel);
}

export function getSelectOptionValue(option, fallback = '') {
  if (!option) {
    return fallback;
  }
  if (Array.isArray(option)) {
    return option[0]?.value || fallback;
  }
  return option.value || fallback;
}
